//
//  Hdf Reducer
//  CXA Apollo
//
//  Created on 29/11/2016.
//  Copyright (c) 2016 CXA. All rights reserved.
//

// Add ALL your actions into import list
import {
  HDF_LOAD_REQUEST,
  HDF_LOAD_SUCCESS,
  HDF_LOAD_FAILURE,
  HDF_SAVE_REQUEST,
  HDF_SAVE_SUCCESS,
  HDF_SAVE_FAILURE,
} from "../actions/hdfActions";

const initialState = {
  employeeParticulars: {
    byId: {},
    all: [],
  },
  membersWithUW: [],
  fetching: false,
  fetched: false,
  saving: false,
  saved: false,
  error: null,
};

const formatHdfDataById = data => {
  const { hdfData } = data;
  return hdfData.reduce((obj, item) => ({ ...obj, [item.fieldName]: item }), {});
};

const formatHdfDataAll = data => {
  const { hdfData } = data;
  return hdfData.map(item => item.fieldName);
};

const getMembersWithUW = members => {
  if (members) {
    return members.map(member => {
      const { memberType, relationship } = member;

      if (memberType === "Employee") {
        return "Emp";
      }

      // Added support for relationship === "Partner" to enable Sp questions in hdf
      if (memberType === "Dependant" && (relationship === "Spouse" || relationship === "Partner")) {
        return "Sp";
      }

      if (memberType === "Dependant" && relationship === "Child") {
        return "Ch";
      }

      return "";
    });
  }

  return [];
};

export const getInitialValues = state =>
  Object.values(state.byId).reduce(
    (obj, item) => ({
      ...obj,
      [item.fieldName]: item.fieldValue,
    }),
    {}
  );

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case HDF_LOAD_REQUEST:
      return { ...state, fetching: true };

    case HDF_LOAD_FAILURE:
      return { ...state, fetching: false, error: payload };

    case HDF_LOAD_SUCCESS: {
      const { isWithMembersWithUWData, membersWithUW: membersWithUWData } = payload;

      const employeeParticulars = {
        byId: formatHdfDataById(payload),
        all: formatHdfDataAll(payload),
      };

      const membersWithUW = isWithMembersWithUWData ? getMembersWithUW(membersWithUWData) : [];

      return {
        ...state,
        fetching: false,
        fetched: true,
        employeeParticulars,
        membersWithUW,
      };
    }

    case HDF_SAVE_REQUEST:
      return { ...state, saving: true };

    case HDF_SAVE_SUCCESS:
      return { ...state, saving: false, saved: true, response: payload };

    case HDF_SAVE_FAILURE:
      return { ...state, saving: false, error: payload };

    default:
      return state; // return previous state
  }
};



// WEBPACK FOOTER //
// ./reducers/hdfReducer.js